/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A condition field type and the operators legal for it.
 * @export
 * @interface FieldTypeMeta
 */
export interface FieldTypeMeta {
    /**
     * 
     * @type {string}
     * @memberof FieldTypeMeta
     */
    value: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldTypeMeta
     */
    operators: Array<string>;
}

/**
 * Check if a given object implements the FieldTypeMeta interface.
 */
export function instanceOfFieldTypeMeta(value: object): value is FieldTypeMeta {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('operators' in value) || value['operators'] === undefined) return false;
    return true;
}

export function FieldTypeMetaFromJSON(json: any): FieldTypeMeta {
    return FieldTypeMetaFromJSONTyped(json, false);
}

export function FieldTypeMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldTypeMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'operators': json['operators'],
    };
}

export function FieldTypeMetaToJSON(json: any): FieldTypeMeta {
    return FieldTypeMetaToJSONTyped(json, false);
}

export function FieldTypeMetaToJSONTyped(value?: FieldTypeMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'operators': value['operators'],
    };
}

